<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Authors</mat-label>
  <!-- The current list of Authors as Chips -->
  <mat-chip-grid #currentAuthorList>
    @for (author of authors(); track author){
    <mat-chip-row [removable]="removable" (removed)="removeEvt(author)" color="primary">
      {{ author }}
      @if (removable) {
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
    }
    <!-- The input field for adding new Authors -->
    <input #authorInput placeholder="Add Author..."  [matAutocomplete]="auto" [formControl]="authorCtrl" 
      [matChipInputFor]="currentAuthorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="addEvt($event)" />
  </mat-chip-grid>
  <!-- The Autocomplete dropdown for selecting Authors -->
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedEvt($event)">
    @for (name of (filteredNames | async ); track name ) {
    <mat-option [value]="name">
      {{ name }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>